import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Component, ElementRef, HostListener, Input, Renderer2, inject } from '@angular/core';
import { AssemblyOrderModel } from 'src/app/models/assembly-order.model';
import { AssemblyOrderService } from 'src/app/services/assembly-order.service';
import { ToastService } from 'src/app/services/toast.service';
import { AssemblyOrderEnum } from '../../enumerators/assembly-order.enum';
import { PoolShellStatusEnum } from '../../enumerators/pool-shell-status.enum';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-in-transit',
    templateUrl: './in-transit.component.html',
    styleUrls: ['./in-transit.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({
                opacity: 0,
            })),
            transition('void <=> *', animate(300)),
        ]),
    ],
    imports: []
})
export class InTransitComponent {
  private readonly _elementRef = inject(ElementRef);
  private readonly toastr = inject(ToastService);
  usrSvc = inject(UserService);
  private readonly assemblySvc = inject(AssemblyOrderService);
  private readonly renderer = inject(Renderer2);

  @Input() disabled: boolean = false;
  @Input() assemblyOrder!: AssemblyOrderModel;

  popupDirection: 'left' | 'right' = 'right';
  
  async handleInTransitChange() {
    if (this.usrSvc.hasPermission('edit:intransit')) {
      await this.inTransitChange();
    } else {
      console.error('No tiene permiso para cambiar este estado');
    }
  }

  async inTransitChange() {
    if (
      this.assemblyOrder.statusId != AssemblyOrderEnum.Cancelada &&
      this.assemblyOrder.statusId != AssemblyOrderEnum.Bloqueada
    ) {
      if (this.assemblyOrder.poolShell.statusId == PoolShellStatusEnum.Lista) {
        const response = await this.assemblySvc.updatePoolShellTransit(
          this.assemblyOrder.poolShell.id,
          !this.assemblyOrder.poolShell.inTransit
        );
        if(response) this.assemblyOrder.poolShell.inTransit = !this.assemblyOrder.poolShell.inTransit
      } else {
        this.assemblySvc.updatePoolShellTransit(
          this.assemblyOrder.poolShell.id,
          false
        );
      }
    }
  }
}
